export class CustomerDetail {
  //   FirstName = "";
  //   LastName = "";
  //   Address = "";
  //   AptSuite = "";
  //   City = "";
  //   PostalCode = "";
  //   CountryCode = "";
  //   Country = "";
  //   ProvStateCode = "";
  //   ProvState = "";
  //   Email = "";
  //   Phone = "";
  //   Password = "";
  //   ConfirmPassword = "";

  constructor() {
    // let FirstName = "";
    // let LastName = "";
    // let Address = "";
    // let AptSuite = "";
    // let City = "";
    // let PostalCode = "";
    // let CountryCode = "";
    // let Country = "";
    // let ProvStateCode = "";
    // let ProvState = "";
    // let Email = "";
    // let Phone = "";
    // let Password = "";
    // let ConfirmPassword = "";
  }
}

export class CustomerDetailsUtils {
  constructor() {
    // this.productId = productId;
    // this.isAnnualBilling = isAnnualBilling;
    // this.price = price;
  }

  reviveCustomerDetailObj() {
    let newCustDetail = new CustomerDetail();
    let oldCustDetail = JSON.parse(
      localStorage.getItem("customerDetail"),
      new CustomerDetail()
    );

    for (var key in oldCustDetail) {
      if (Object.prototype.hasOwnProperty.call(oldCustDetail, key)) {
        newCustDetail[key] = oldCustDetail[key];
      }
      // if (oldCart.hasOwnProperty(key)) {
      //   newCart[key] = oldCart[key];
      // }
    }

    // newCart.CartItems = [];
    // let cis = oldCart.CartItems;

    // cis.forEach(el => {
    //     let newCI = new CartItem();
    //     for (var key in el) {
    //         if (Object.prototype.hasOwnProperty.call(el, key)) {
    //             newCI[key] = el[key];
    //         }

    //         //   if (el.hasOwnProperty(key)) {
    //         //     newCI[key] = el[key];
    //         //   }
    //     }
    //     newCart.CartItems.push(newCI);
    // });

    return newCustDetail;
  }
}
